import { AuthData } from '@/models/auth';
/**
 * Class for easy use localStorage
 */
export default class HelperStorage {
  /**
   * Allow set value
   * @name: name of variable
   * @value: any value, value will be stringify
   */
  public static set(name: string, value: AuthData): void {
    localStorage.setItem(name, JSON.stringify(value));
  }

  /**
   * Allow get value with default value if value not exist
   * @name: name of variable
   * @defaultValue: value that we want return if value not exist
   */
  public static get(name: string, defaultValue: AuthData): AuthData {
    const data: string | null = localStorage.getItem(name);
    let response: AuthData;
    if (data) {
      response = JSON.parse(data);
    } else {
      response = defaultValue;
    }
    return response;
  }

  public clear(): void {
    localStorage.clear();
  }
}
